'use client'

import Script from 'next/script'
import { usePathname, useSearchParams } from 'next/navigation'
import React, { Suspense, useEffect, useRef } from 'react'

import { METRIKA_ID, reachPageView } from '@/analytics/metrika'

/**
 * Счётчик Метрики. Первый просмотр отправляет сам скрипт, дальше переходы
 * идут без перезагрузки страницы — их досылаем руками.
 */
function PageViews() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const query = searchParams?.toString()
  // первый просмотр отправляет сам счётчик при инициализации, поэтому
  // запоминаем адрес и шлём только следующие. Сравнение по адресу, а не
  // «первый раз», чтобы повторный прогон эффектов ничего не задваивал.
  const lastSent = useRef<string | null>(null)

  useEffect(() => {
    const url = `${pathname}${query ? `?${query}` : ''}`
    if (lastSent.current === null) {
      lastSent.current = url
      return
    }
    if (lastSent.current === url) return
    lastSent.current = url
    reachPageView(`${window.location.origin}${url}`)
  }, [pathname, query])

  return null
}

export function Metrika() {
  if (!METRIKA_ID) return null

  return (
    <>
      <Script id="metrika" strategy="afterInteractive">
        {`
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

          ym("${METRIKA_ID}", "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true
          });
        `}
      </Script>

      <noscript>
        <div>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img alt="" src={`https://mc.yandex.ru/watch/${METRIKA_ID}`} style={{ position: 'absolute', left: '-9999px' }} />
        </div>
      </noscript>

      <Suspense fallback={null}>
        <PageViews />
      </Suspense>
    </>
  )
}
